import { PaginatedResponse, PriorityComment } from "@/types";
import { apiClient } from "@/lib/apiClient";

export const commentService = {
  getComments: async (
    priorityPid: string,
    page: number = 1,
    limit: number = 20,
  ): Promise<PaginatedResponse<PriorityComment>> => {
    return apiClient.get<PaginatedResponse<PriorityComment>>(
      `/api/priorities/${priorityPid}/comments`,
      { params: { page: page.toString(), limit: limit.toString() } },
    );
  },

  addComment: async (
    priorityPid: string,
    content: string,
  ): Promise<PriorityComment> => {
    return apiClient.post<PriorityComment>(
      `/api/priorities/${priorityPid}/comments`,
      { content },
    );
  },

  updateComment: async (
    commentPid: string,
    content: string,
  ): Promise<PriorityComment> => {
    return apiClient.put<PriorityComment>(
      `/api/priorities/comments/${commentPid}`,
      { content },
    );
  },

  deleteComment: async (commentPid: string): Promise<void> => {
    return apiClient.delete<void>(
      `/api/priorities/comments/${commentPid}`,
    );
  },
};
